import React, { useState } from "react";
import { Button, InputGroup, Menu, MenuItem } from "@blueprintjs/core";

const CustomDropdown = ({ items, selectedItem, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleSearchChange = (e) => setSearchQuery(e.target.value);

  const filteredItems = items.filter((item) =>
    item.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div style={{ position: "relative", width: "250px", marginRight: "20px" }}>
      {/* Dropdown Button */}
      <Button
        rightIcon="caret-down"
        alignText="left"
        text={selectedItem ? selectedItem.title : "Goal Cycle"}
        onClick={toggleDropdown}
        style={{
          width: "250px",
          background: "white",
          padding: "10px 8px 10px 12px",
          borderRadius: "20px",
        }}
      />

      {/* Dropdown Content */}
      {isOpen && (
        <div
          style={{
            position: "absolute",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            borderRadius: "4px",
            padding: "8px 0",
            width: "250px",
            marginTop: "4px",
            marginLeft: "10px",
            background: "white",
            zIndex: 10,
          }}
        >
          {/* Search Bar */}
          {items.length > 10 && (
            <InputGroup
              leftIcon="search"
              placeholder="Search"
              value={searchQuery}
              onChange={handleSearchChange}
              style={{ marginBottom: "8px", padding: "4px" }}
            />
          )}

          {/* Scrollable Menu */}
          <div style={{ maxHeight: items.length > 5 ? "150px" : "auto", overflowY: items.length > 10 ? "scroll" : "visible" }}>
            <Menu>
              {filteredItems.length > 0 ? (
                filteredItems.map((item) => (
                  <MenuItem key={item.id} text={item.title} onClick={() => { onSelect(item); setIsOpen(false); }} />
                ))
              ) : (
                <MenuItem disabled text="No results found" />
              )}
            </Menu>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
